// export class DateAdapter {
//   static fromAPI(payload: any, fields: string[]): any {
//     const result = structuredClone(payload);
//     fields.forEach((field) => {
//       if (result[field]) {
//         result[field] = new Date(result[field]);
//       }
//     });
//     return result;
//   }

//   static toAPI(payload: any, fields: string[]): any {
//     const result = structuredClone(payload);
//     fields.forEach((field) => {
//       if (result[field]) {
//         result[field] = result[field].toISOString();
//       }
//     });
//     return result;
//   }
// }


export class DateAdapter {
  static fromAPI(payload: any, fields: string[]): any {
    return this._adaptDates(payload, fields, 'from');
  }

  static toAPI(payload: any, fields: string[]): any {
    return this._adaptDates(structuredClone(payload), fields, 'to');
  }

  private static _adaptDates(obj: any, fields: string[], direction: 'from' | 'to'): any {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
    for (const key in obj) {
      if (!Object.hasOwn(obj, key)) continue;

      const value = obj[key];

      if (fields.includes(key)) {
        if (direction === 'from' && typeof value === 'string') {
          obj[key] = new Date(value);
        } else if (direction === 'to' && value instanceof Date) {
          obj[key] = value.toISOString();
        }
      }
      else if (Array.isArray(value)) {
        obj[key] = value.map((item) => this._adaptDates(item, fields, direction));
      } else if (value && typeof value === 'object') {
        obj[key] = this._adaptDates(value, fields, direction);
      }
    }

    return obj;
  }
}
